import { ContainerContdown } from "./styles";
import bg3 from '../../assets/bg3.png';
import  { useState, useEffect } from "react";

export function Countdown() {
    const [ timerDays, setTimerDays ] = useState('00');
    const [ timerHours, setTimerHours ] = useState('00');
    const [ timerMinutes, setTimerMinutes ] = useState('00');

    useEffect(() => {
        const futureDate = new Date("25 May 2022 20:00 UTC")

        const interval = setInterval(() => {
            const currentTime = new Date()

            const dataDifference = futureDate.getTime() - currentTime.getTime()

            const days = Math.floor(dataDifference / 1000 / 60 / 60 / 24).toString()
            setTimerDays(days)

            const hours = Math.floor((dataDifference / 1000 / 60 / 60 ) % 24).toString()
            setTimerHours(hours)

            const minutes = Math.floor((dataDifference / 1000 / 60) % 60).toString()
            setTimerMinutes(minutes)

        }, 1000)

        return () => clearInterval(interval)
    }, [])

    return(
        <ContainerContdown>
            <h1>
                Fractalia Party
            </h1>
            <div className="countdown">
                <div className="days">
                    <div>
                        <img src={bg3} alt="circle that surrounds the day" />
                        <div className="number" id="day">{timerDays}</div>
                    </div>
                    <h6>DAYS</h6>
                </div>
                <div className="hours">
                    <div>
                        <img src={bg3} alt="circle that surrounds the hours" />
                        <div className="number" id="hour">{timerHours}</div>
                    </div>
                    <h6>HOURS</h6>
                </div>
                <div className="minutes">
                    <div>
                        <img src={bg3} alt="circle that surrounds the minutes" />
                        <div className="number" id="minute">{timerMinutes}</div>
                    </div>
                    <h6>MINUTES</h6>
                </div>
            </div>
            <div className="discord">
                <a href="https://bit.ly/3MtW0Up" target="_blank" rel="noreferrer"> 
                    VIEW EVENT
                </a>
            </div>
        </ContainerContdown>
    )
}